// Static content for The Sesh With Sav
// Latest YouTube video ID (hardcoded per user choice)
export const LATEST_VIDEO_ID = "zQ5pPKvuutI";

export const SOCIAL_LINKS = {
  youtube: "https://youtube.com/@theseshwithsav384",
  apple: "https://podcasts.apple.com/au/podcast/the-sesh-with-sav/id1625593245",
  spotify: "https://open.spotify.com/show/0Qx5DKpRDuyEsl0v7QyXz1",
  merch: "https://theseshwithsav.bigcartel.com",
  instagram: "https://instagram.com/theseshwithsav",
};

// Apple Podcasts embed widget ID
export const APPLE_PODCAST_ID = "1625593245";

// Curated list of recent episodes — used as fallback if API not yet hit
export const FALLBACK_VIDEOS = [
  { id: "zQ5pPKvuutI", title: "COMPLETE | The Rap GOAT Of Perth", episode: 210, duration: "53:01" },
  { id: "3NNtP93LOY0", title: "SAV | The Last Podcast In This Studio", episode: 209, duration: "57:31" },
  { id: "ws0YBN4qD40", title: "Abbie Chatfield Is Losing It | Hantavirus & Impending Doom", episode: 208, duration: "19:16" },
  { id: "LMAf_04FgBY", title: "Sean Strickland Just SHOCKED The UFC World", episode: 207, duration: "4:55" },
  { id: "w5D_K8L3F54", title: "UFC 328 | Breakdown & Picks", episode: 206, duration: "10:50" },
  { id: "w3zwU3xKyZo", title: "Who is the Greatest Australian Rap Artist?", episode: 205, duration: "8:46" },
  { id: "fgH-qNeqTDE", title: "MANAZ | The Return to Battle Rap", episode: 204, duration: "57:15" },
  { id: "P6MidCQa4IU", title: "Adam Ludewig | The Truth Behind 'The Voice'", episode: 195, duration: "1:05:33" },
  { id: "uymUme2LbKk", title: "James Webb | JWEBBY CAN EAT", episode: 193, duration: "1:06:47" },
  { id: "paSp3I-yito", title: "Ryan Naumenko | The Tobacco War", episode: 192, duration: "1:59:05" },
];

// Placeholder merch items (linking to bigcartel store)
export const MERCH_ITEMS = [
  {
    id: "tee-black",
    name: "TSWS Logo Tee — Black",
    price: "$45 AUD",
    image: "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=800&q=80&auto=format&fit=crop",
    tag: "ESSENTIAL",
  },
  {
    id: "hoodie-red",
    name: "The Sesh Hoodie — Blood Red",
    price: "$95 AUD",
    image: "https://images.unsplash.com/photo-1556821840-3a63f95609a7?w=800&q=80&auto=format&fit=crop",
    tag: "NEW DROP",
  },
  {
    id: "cap-snapback",
    name: "Sesh Snapback Cap",
    price: "$40 AUD",
    image: "https://images.unsplash.com/photo-1588850561407-ed78c282e89b?w=800&q=80&auto=format&fit=crop",
    tag: "RESTOCKED",
  },
  {
    id: "stubby",
    name: "Quality Banter Stubby Holder",
    price: "$18 AUD",
    image: "https://images.unsplash.com/photo-1608270586620-248524c67de9?w=800&q=80&auto=format&fit=crop",
    tag: "ICONIC",
  },
  {
    id: "tee-white",
    name: "TSWS Tour Tee — White",
    price: "$45 AUD",
    image: "https://images.unsplash.com/photo-1583743814966-8936f5b7be1a?w=800&q=80&auto=format&fit=crop",
    tag: "LIMITED",
  },
  {
    id: "poster",
    name: "Episode 200 Poster",
    price: "$25 AUD",
    image: "https://images.unsplash.com/photo-1567593810070-7a3d471af022?w=800&q=80&auto=format&fit=crop",
    tag: "COLLECTOR",
  },
];

// Hero/section images
export const IMAGES = {
  logo: "https://customer-assets.emergentagent.com/job_the-sesh-official/artifacts/s2begi84_ab6765630000ba8a7652999bf92a35a7c0fe77e1_1.jpeg",
  heroMic:
    "https://images.unsplash.com/photo-1552174588-6733961c358e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwzfHxwb2RjYXN0JTIwbWljcm9waG9uZSUyMGRhcmslMjBzdHVkaW98ZW58MHx8fHwxNzgwNjU1Nzk5fDA&ixlib=rb-4.1.0&q=85",
  beers:
    "https://images.unsplash.com/photo-1598614522213-6b7bd8726a3c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHwyfHxjaGVlcnMlMjBiZWVyJTIwZ2xhc3NlcyUyMGRhcmt8ZW58MHx8fHwxNzgwNjU1Nzk5fDA&ixlib=rb-4.1.0&q=85",
  skyline:
    "https://images.unsplash.com/photo-1543852942-5074cb5a8bbf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHwyfHxwZXJ0aCUyMHNreWxpbmUlMjBuaWdodHxlbnwwfHx8fDE3ODA2NTU3OTl8MA&ixlib=rb-4.1.0&q=85",
};

export const TAGLINE = "Talking to cool people about cool shit.";
